import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from './Header'
import '../layouts/index.css'

const TemplateWrapper = ({ children, location }) => (
  <div id="wrapper">
    <Helmet
      title="Dana Bennett - Web Developer"
      meta={[
        { name: 'description', content: 'All about Dana Bennett' },
        { name: 'keywords', content: 'dana bennett' },
      ]}
    >
      <link
        rel="apple-touch-icon"
        sizes="120x120"
        href="/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
      <meta name="msapplication-TileColor" content="#da532c" />
      <meta name="theme-color" content="#ffffff" />
    </Helmet>
    <Header pathName={location.pathname} />
    <div className="main">{children}</div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.node,
}

export default TemplateWrapper
